export default __webpack_public_path__ + "static/media/google-store.6e7451d8.svg";